import { useContext } from "react";
import { AuthContext, IAuthContext } from "../contexts/AuthContext";
import { TServiceResponse } from "../services/Modals";
import { INotificationContext, NotificationContext } from "../contexts/NotificationContext";
import Cookies from "universal-cookie";
import { CustomerContext, ICustomerContext } from "../contexts/CustomerContext";
import { TTransactionContext, TransactionContext } from "../contexts/TransactionContext";
import { IInventoryContext, InventoryContext } from "../contexts/InventoryContext"
import { EmployeeContext, IEmployeeContext } from "../contexts/EmployeeContext";
import {TEcomTransactionContext, EcomTransactionContext} from "../contexts/ecomOrderContext";

export type TStore = {
  authStore: IAuthContext;
  customerStore: ICustomerContext;
  transactionsStore: TTransactionContext;
  inventoryStore: IInventoryContext;
  notificationStore: INotificationContext;
  employeeStore: IEmployeeContext;
  ecomTransactionStore: TEcomTransactionContext;
};
// interface
const useService = () => {
  const authStore = useContext(AuthContext);
  const customerStore = useContext(CustomerContext);
  const transactionsStore = useContext(TransactionContext);
  const ecomTransactionStore = useContext(EcomTransactionContext);
  const inventoryStore = useContext(InventoryContext);
  const notificationStore = useContext(NotificationContext);
  const employeeStore = useContext(EmployeeContext);
  const { notify, loading, setLoading } = notificationStore
  const { setAuthState } = authStore;
  const cookies = new Cookies();
  const store:TStore = { authStore, customerStore, transactionsStore, inventoryStore, notificationStore, employeeStore,ecomTransactionStore }

  const execute = async <T>(
    service: () => (store: TStore) => Promise<TServiceResponse<T>>
  ): Promise<TServiceResponse<T>> => {

    setLoading(true);
    const { error, data } = await service()(store);
    setLoading(false);

    if (error !== null) {
      notify(error.reason, "error");
      if (error?.code === "05") {
        setAuthState({ sessionId: "" });
        cookies.remove("sessionId");
      }
    }

    return { error, data };
  };

  return { execute, loading, store };
};

export default useService;
